// extracted by mini-css-extract-plugin
module.exports = {"service":"statusPanel_service__1l1ZJ","panel":"statusPanel_panel__29g55","status":"statusPanel_status__3YCtJ"};